﻿cb.define([], function () {
	var AA_aa_paramadjustlist_VM_Extend = {
		doAction: function (name,viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {
			
			
			//根据单据状态，设置行上的按钮是否显示
			let gridModel = viewmodel.getGridModel();
			gridModel.on('afterSetDataSource', () => {
				const rows = gridModel.getRows();
				const actions = gridModel.getCache('actions');
				const actionsStates = [];
				rows.forEach(data => {
					const actionState = { };
					actions.forEach(action => {
						actionState[action.cItemName] = { visible: false };
						if (data.status == 0) {
							actionState["btnEdit"] = {visible:true};
							actionState["btnDelete"] = {visible:true};
							actionState["btnRowAudit"] = {visible:true};
						}
						if (data.status == 1) {

						}
					});
					actionsStates.push(actionState);
				});
				gridModel.setActionsState(actionsStates);
			});
			
		}
	}

	try {		
		module.exports = AA_aa_paramadjustlist_VM_Extend;
	} catch (error) {

	}
	return AA_aa_paramadjustlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_paramadjustlist_VM.Extend.js